<div class="small-warpper">
  <app-card [config]="config">{{'common.card.no-data.explaination' | translate}}</app-card>
</div>
